import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[TaskTool] UI error:', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="page" style={{ maxWidth: 520, margin: '80px auto', textAlign: 'center' }}>
          <h2>Something went wrong</h2>
          <p className="text-muted">
            An unexpected error occurred while displaying this page. You can return to the dashboard and try again.
          </p>
          <button className="btn btn-primary" onClick={this.handleReset}>Back to Dashboard</button>
        </div>
      );
    }
    return this.props.children;
  }
}
